import { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Stack,
  Text,
  useDisclosure,
  useToast
} from "@chakra-ui/react";
import { CollecticonChevronDownSmall } from "@devseed-ui/collecticons-chakra";
import { useModels } from "../../../context";
import API from "../../../api";

type Props = {
  sceneId: string;
  onSubmit: () => void;
}

function RunModel({ sceneId, onSubmit }: Props) {
  const toast = useToast();
  const { models } = useModels();
  const { isOpen, onToggle, onClose } = useDisclosure();
  const [ selectedModels, setSelectedModels ] = useState<(string | number)[]>([]);

  const handleFormSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    onClose();
    const selected = models.filter(({ id }) => selectedModels.includes(`${id}`));
    Promise.all(selected.map((m) =>
      API.ingest(sceneId, m).then(() =>
        toast({
          title: "Success",
          description: `Request to run model ${m.name} succeeded.`,
          status: "success",
          duration: 5000,
          isClosable: true,
        })
      ).catch(() =>
        toast({
          title: "Error",
          description: `Request to run the model ${m.name} failed.`,
          status: "error",
          duration: 5000,
          isClosable: true,
        })
      )
    )).then(onSubmit);
  };

  return (
    <Popover isOpen={isOpen} onClose={onClose}>
      <PopoverTrigger>
        <Button w="100%" variant="base-soft-outline" rightIcon={<CollecticonChevronDownSmall />} onClick={onToggle}>Run models</Button>
      </PopoverTrigger>
      <PopoverContent>
        <form onSubmit={handleFormSubmit}>
          <PopoverArrow />
          <PopoverBody>
            <Box as="fieldset">
              <Text as="legend" fontWeight="bold">Select models</Text>
              <CheckboxGroup value={selectedModels} onChange={setSelectedModels}>
                <Stack spacing="4" direction="column" mt="2" mb="4">
                  { models.map(({ id, name, version }) => (
                    <Checkbox key={id} value={`${id}`}>{name} ({ version })</Checkbox>
                  ))}
                </Stack>
              </CheckboxGroup>
            </Box>
            <Box textAlign="right">
              <Button width="40%" type="submit">
                {selectedModels.length > 1 ? "Run models" : "Run model"}
              </Button>
            </Box>
          </PopoverBody>
        </form>
      </PopoverContent>
    </Popover>
  );
}

export default RunModel;
